(() => {
  const FULL_WALL_HEIGHTS = [
    '230', '240', '250', '260',
    '270', '280', '290', '300'
  ];

  const WAINSCOT_HEIGHTS = [
    '120', '140', '160', '180'
  ];

  let selectedApplication = 'full-wall';
  let updateTimer;

  function getHeight(text) {
    const match = String(text).match(/\d+/);
    return match ? match[0] : '';
  }

  function getApplicationFieldset(picker) {
    return picker.querySelector('[data-wallpaper-application]');
  }

  function getHeightFieldset(picker) {
    return Array.from(
      picker.querySelectorAll('[data-option-name]')
    ).find((fieldset) => {
      return (fieldset.dataset.optionName || '')
        .toLowerCase()
        .includes('hoogte');
    });
  }

  function getHeightPopover(heightFieldset) {
    const trigger = heightFieldset.querySelector(
      'button.select[aria-controls]'
    );

    if (!trigger) return null;

    const popoverId = trigger.getAttribute('aria-controls');

    return document.getElementById(popoverId);
  }

  function getHeightOptions(heightFieldset) {
    const popover = getHeightPopover(heightFieldset);

    if (!popover) return [];

    return Array.from(
      popover.querySelectorAll('.popover__value-option')
    );
  }

  function synchroniseApplicationButtons(applicationFieldset) {
    applicationFieldset
      .querySelectorAll('input[type="radio"]')
      .forEach((input) => {
        input.checked = input.value === selectedApplication;
      });
  }

  function updatePicker(picker) {
    const applicationFieldset = getApplicationFieldset(picker);
    const heightFieldset = getHeightFieldset(picker);

    if (!applicationFieldset || !heightFieldset) return;

    synchroniseApplicationButtons(applicationFieldset);

    const allowedHeights =
      selectedApplication === 'wainscot'
        ? WAINSCOT_HEIGHTS
        : FULL_WALL_HEIGHTS;

    const options = getHeightOptions(heightFieldset);

    if (!options.length) return;

    let selectedHeightIsAllowed = false;
    let firstAllowedInput = null;

    options.forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      const height = getHeight(label.textContent);
      const isAllowed = allowedHeights.includes(height);

      label.hidden = !isAllowed;
      label.style.display = isAllowed ? '' : 'none';
      label.setAttribute(
        'aria-hidden',
        isAllowed ? 'false' : 'true'
      );

      if (input) {
        input.disabled = !isAllowed;

        if (isAllowed && !firstAllowedInput) {
          firstAllowedInput = input;
        }

        if (isAllowed && input.checked) {
          selectedHeightIsAllowed = true;
        }
      }
    });

    if (!selectedHeightIsAllowed && firstAllowedInput) {
      firstAllowedInput.disabled = false;
      firstAllowedInput.click();
    }
  }

  function updateAllPickers() {
    document
      .querySelectorAll('variant-picker')
      .forEach(updatePicker);
  }

  function scheduleUpdate() {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(() => {
      updateAllPickers();
    }, 50);
  }

  document.addEventListener('change', (event) => {
    const applicationInput = event.target.closest(
      '[data-wallpaper-application] input[type="radio"]'
    );

    if (!applicationInput) return;

    selectedApplication = applicationInput.value;
    scheduleUpdate();
  });

  document.addEventListener('click', (event) => {
    const heightTrigger = event.target.closest(
      '[data-option-name*="Hoogte"] button.select'
    );

    if (heightTrigger) {
      scheduleUpdate();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    updateAllPickers();

    const observer = new MutationObserver(() => {
      scheduleUpdate();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  document.addEventListener('shopify:section:load', () => {
    scheduleUpdate();
  });
})();